import React from 'react'
import { Plus as PlusIcon } from 'react-feather'
import {
  Box,
  Button,
  Card,
  Grid,
  TablePagination,
  Typography,
  useMediaQuery,
} from '@material-ui/core'
import { useTheme } from '@material-ui/styles'
import { useHistory } from 'react-router-dom'

import {
  Container,
  ContentHeader,
  FilterButton,
  LoadingBox,
  Page,
  Permitted,
} from 'components'

import { SSOCorporateGroupTable, SSOCorporateGroupFilter } from './components'

import { useFetch, useFilter, usePagination } from 'hooks'

import * as service from 'service'
import constants from 'constants/index'
import { routes } from 'Routes'

const SSOCorporateGroupMain = () => {
  const theme = useTheme()
  const history = useHistory()
  const filter = useFilter()

  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(10)

  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  const { response, isLoading, refresh } = useFetch(
    service.dponet.ssoCorporateGroups.get,
    {
      perPage,
      page,
      ...filter.filters,
    },
    [page, perPage, filter.filters],
  )

  const newSsoCorporateGroup = () => {
    history.push(routes.ssoCorporateGroups.new)
  }

  const ssoCorporateGroups = response?.data?.ssoCorporateGroups || []
  return (
    <Page title="Grupos Empresariais SSO-SAML">
      <Container
        maxWidth={false}
        spacingXl={30}
        spacingLg={25}
        spacingMd={10}
        spacingSm={10}
      >
        <ContentHeader
          menu="Grupos Empresariais SSO-SAML"
          title="Listagem"
          subtitle="Exibição dos Grupo Empresariais SSO-SAML"
        >
          <Box ml={1}>
            <FilterButton setDrawerOpen={filter.setDrawerOpen} />
          </Box>
        </ContentHeader>
        <Card>
          <Box display="flex" width="100%">
            <Grid container>
              <Grid item xs={6}>
                <Box
                  width="100%"
                  p={2}
                  height="100%"
                  display="flex"
                  alignItems="center"
                >
                  <Typography variant="h5">
                    Grupos Empresariais com Login SSO-SAML
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={6}>
                <Box p={2} display="flex" justifyContent="flex-end">
                  <Permitted
                    tag={constants.permissions.SSO_CORPORATE_GROUP.CREATE}
                  >
                    <Button
                      variant="outlined"
                      color="primary"
                      startIcon={<PlusIcon />}
                      onClick={newSsoCorporateGroup}
                    >
                      Criar
                    </Button>
                  </Permitted>
                </Box>
              </Grid>
            </Grid>
          </Box>
          {isLoading ? (
            <LoadingBox />
          ) : (
            <SSOCorporateGroupTable
              ssoCorporateGroups={ssoCorporateGroups}
              refresh={refresh}
            />
          )}
          <Box px={2} display="flex" justifyContent="flex-end">
            <TablePagination
              component="div"
              count={response?.data?.meta?.totalCount || 0}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              page={page - 1}
              rowsPerPage={perPage}
              rowsPerPageOptions={[5, 10, 25, 100]}
              labelRowsPerPage={isDesktop ? 'Por página' : ''}
              nextIconButtonProps={{ size: 'small' }}
              backIconButtonProps={{ size: 'small' }}
            />
          </Box>
        </Card>
        <SSOCorporateGroupFilter filter={filter} />
      </Container>
    </Page>
  )
}
export default SSOCorporateGroupMain
